<template>
  <div id="c3-schedule-au" class="schedule">
    <ReportDraftWatermark v-if="report.is_draft" />
    <h2 class="formTitle">Schedule AU: Auction Report</h2>
    <div class="report-section" v-for="(auction, index) in auctions" :key="index">
      <h4 class="line-item-title">Date auction was held: {{ formatDate(auction.date) }}</h4>
      <v-simple-table dense class="au-table">
        <thead>
        <tr>
          <th>
            Item No. Description
          </th>
          <th>
            Contributor
          </th>
          <th>Buyer</th>
          <th class="amountColumn">
            Fair Market Value
          </th>
          <th class="amountColumn">
            Sale Price
          </th>
          <th class="auctionAmountColumn">
            Amount Over Fair Market Value
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in auction.items" :key="index">
          <td>
            {{ item.description }}
          </td>
          <td>
            <ContactInfo :contId="item.donate.contact_key" :contacts="report.user_data.contacts"/>
            ({{ electionFilter(item.buy.election) }})
            {{ formatMoney(getAggregateTotal(contacts, item.donate.contact_key, item.donate.election)) }} total<br/>
            <div>
              <RecipientInfo :contacts="report.user_data.contacts" :cont-id="item.donate.contact_key"/>
            </div>
          </td>
          <td>
            <ContactInfo :contId="item.buy.contact_key" :contacts="report.user_data.contacts"/>
            ({{ electionFilter(item.buy.election) }})
            {{ formatMoney(getAggregateTotal(contacts, item.buy.contact_key, item.buy.election)) }} total<br/>
            <div>
              <RecipientInfo :contacts="report.user_data.contacts" :cont-id="item.buy.contact_key"/>
            </div>
          </td>
          <td class="amountColumn">{{ formatMoney(item.market_value) }}</td>
          <td class="amountColumn">{{ formatMoney(item.sale_amount) }}</td>
          <td class="amountColumn"><span
              v-if="amountOver(item.market_value,item.sale_amount) > 0">{{ formatMoney(amountOver(item.market_value, item.sale_amount)) }}</span>
          </td>
        </tr>
        </tbody>
      </v-simple-table>
      <v-divider></v-divider>
    </div>
    <h3 class="line-item-title">Total auctions cash receipts (sale price):
      <strong>{{ formatMoney(report.metadata.sums.misc_auction.amount) }}</strong></h3>
  </div>
</template>

<script>
import filters from "../filters";
import utils from "./report-utils";
import ContactInfo from "./ContactInfo";
import RecipientInfo from "./RecipientInfo";
import ReportDraftWatermark from "@/components/ReportDraftWatermark";

export default {
  name: "C3ScheduleAU",
  components: {ContactInfo, RecipientInfo, ReportDraftWatermark},
  props: {
    report: Object
  },
  data() {
    return {
      auctions: {},
    }
  },
  methods: {
    ...filters.filters, ...utils,
    amountOver(market_value, sale_price) {
      let contribution = sale_price - market_value
      if (contribution > 0) {
        return contribution
      } else {
        return 0
      }
    }
  },
  created() {
    this.auctions = this.report.user_data.auctions;
  },
  computed: {
    contacts() {
      return this.report.user_data.contacts;
    }
  }
}

</script>
<style scoped>
  #c3-schedule-au { position: relative }
</style>